/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureplacefromwebsite4Inputs */

const en_aifeatureplacefromwebsite4 = /** @type {(inputs: Aifeatureplacefromwebsite4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place from website`)
};

const de_aifeatureplacefromwebsite4 = /** @type {(inputs: Aifeatureplacefromwebsite4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort aus der Website`)
};

/**
* | output |
* | --- |
* | "Place from website" |
*
* @param {Aifeatureplacefromwebsite4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureplacefromwebsite4 = /** @type {((inputs?: Aifeatureplacefromwebsite4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureplacefromwebsite4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureplacefromwebsite4(inputs)
	return de_aifeatureplacefromwebsite4(inputs)
});
export { aifeatureplacefromwebsite4 as "aiFeaturePlaceFromWebsite" }